<template>
	<div>
		<el-dialog :title="editForm.id==null||editForm==''?$t('deng-ji-chong-dian-zhuang'):$t('bian-ji-chong-dian-zhuang')" :visible="editFormVisible"
			:modal-append-to-body='false' :close-on-click-modal="false"
			:close-on-press-escape="editForm.id!=null&&editForm!=''" :before-close="clearEditForm">
			<el-form :model="editForm" ref="editForm" size="mini" class="edit_form" :rules="editFormRules">
				<el-col :span="12">
					<el-form-item :label="$t('deviceControl.pileId')" :label-width="formLabelWidth" prop="pileCode">
						<el-input v-model="editForm.pileCode" autocomplete="off" :placeholder="$t('qing-she-zhi-zhuang-bian-hao')" maxlength="20">
							<el-button slot="append" icon="el-icon-edit" @click="pileShow=!pileShow"></el-button>
						</el-input>
						<el-popover width="400" v-model="pileShow">
							<el-divider content-position="left">{{ $t('she-zhi-chong-dian-zhuang-bian-ma') }}</el-divider>
							<el-form label-width="100px" :model="pileForm" ref="pileForm" size="mini" class="edit_form"
								:rules="pileFormRules">
								<el-form-item :label="$t('deviceControl.operatorId')" prop="code">
									<el-cascader size="mini" clearable ref="cascaderPile" :placeholder="$t('deviceControl.operatorId')" :options="operatorTree"
										:props="{ checkStrictly:true,expandTrigger:'hover'}" :show-all-levels="false" change-on-select
										@change='handleChangeCode' v-model="pileForm.code">
									</el-cascader>
								</el-form-item>
								<el-form-item :label="$t('chong-dian-zhuang-huan-jing')" prop="reservedBit1">
									<el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="pileForm.reservedBit1">
										<el-option v-for="item in pileState" :key="item.value" v-bind:label="item.message"
											v-bind:value="item.value"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item :label="$t('bao-liu-wei')">
									<el-input v-model="pileForm.reservedBit2" disabled></el-input>
								</el-form-item>
								<el-form-item :label="$t('di-qu-bian-ma')" prop="areaCode">
									<el-input v-model="pileForm.areaCode" maxlength="3" :placeholder="$t('qu-hao-qu-suo-zai-di-qu-de-qu-hao-qian-san-wei-shu')"></el-input>
								</el-form-item>
								<el-form-item :label="$t('chong-dian-zhan-xu-hao')" prop="stationNumber">
									<el-input v-model="pileForm.stationNumber" maxlength="3" :placeholder="$t('chong-dian-zhan-xu-hao-wei-san-wei-shu')"></el-input>
								</el-form-item>
								<el-form-item :label="$t('chong-dian-zhuang-xu-hao')" prop="pileNumber">
									<el-input v-model="pileForm.pileNumber" maxlength="3" :placeholder="$t('chong-dian-zhuang-xu-hao-wei-san-wei-shu')"></el-input>
								</el-form-item>
							</el-form>
							<div style="text-align: right; margin: 0">
								<el-button size="mini" type="text" @click="pileEditForm">{{ $t('alaramMonitor.cancel') }}</el-button>
								<el-button type="primary" @click.native="handleClose()">{{ $t('que-ren') }}</el-button>
							</div>
							<!-- <el-button slot="reference">删除</el-button> -->
						</el-popover>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('chong-dian-zhuang-ming-cheng')" :label-width="formLabelWidth" prop="name">
						<el-input v-model="editForm.name" autocomplete="off"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('chong-dian-zhuang-lei-xing')" :label-width="formLabelWidth" prop="pileType">
						<el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.pileType">
							<el-option v-for="item in pileTypeData" :key="item.value" v-bind:label="item.message+$t('zhuang')"
								v-bind:value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('shi-fou-jian-cha-lian-jie')" :label-width="formLabelWidth" prop="checkConnection">
						<el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.checkConnection">
							<el-option v-for="item in checkConnectionData" :key="item.value" v-bind:label="item.message"
								v-bind:value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('shi-fou-zhi-chi-bing-chong')" :label-width="formLabelWidth" prop="together">
						<el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.together">
							<el-option v-for="item in togetherData" :key="item.value" v-bind:label="item.message"
								v-bind:value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('deviceControl.operatorId')" :label-width="formLabelWidth" prop="operatorId">
						<!--          <el-select placeholder="运营商" v-model="editForm.operatorId"  @change="operatorSelect">
            <el-option v-for="item in operatorForSelect" :key="item.id" :disabled="operatorDisable(item)"
                       v-bind:label="item.name" v-bind:value="item.id"></el-option>
          </el-select>-->
						<el-cascader size="mini" ref="cascader" :placeholder="$t('deviceControl.operatorId')" filterable
							:options="this.setTreeDisable(this.operatorTree)"
							:props="{ checkStrictly:true,expandTrigger:'hover'}" :show-all-levels="false"
							change-on-select @change='handleChangeStation' v-model="editForm.operatorId">
						</el-cascader>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('deviceControl.stationName')" :label-width="formLabelWidth" prop="stationId">
						<el-select :placeholder="$t('deviceControl.stationName')" v-model="editForm.stationId" @change="stationSelect">
							<el-option v-for="item in stationsForSelect" :key="item.id" v-bind:label="item.stationName"
								v-bind:value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</el-col>

				<el-col :span="12">
					<el-form-item :label="$t('xing-hao-0')" :label-width="formLabelWidth" prop="pileTypeId">
						<el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.pileTypeId" @change="pileTypeSelect">
							<el-option v-for="item in pileTypeForSelect" :key="item.id"
								v-bind:label="'('+item.typeModel+')  '+item.typeName" v-bind:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('qiang-kou-shu-liang')" :label-width="formLabelWidth" prop="gunCount">
						<el-input disabled v-model="editForm.gunCount" autocomplete="off"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('kuai-man-chong')" :label-width="formLabelWidth" prop="fastOrSlow">
						<el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.fastOrSlow">
							<el-option v-for="item in fastOrSlowData" :key="item.value" v-bind:label="item.message+$t('zhuang')"
								v-bind:value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
        <el-col :span="12">
          <el-form-item label="设备类型" :label-width="formLabelWidth" prop="equipmentType">
            <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.equipmentType">
              <el-option v-for="item in equipmentTypeData" :key="item.value" v-bind:label="item.message"
                         v-bind:value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
				<el-col :span="12">
					<el-form-item :label="$t('e-ding-gong-shuai')" :label-width="formLabelWidth" prop="ratedPower">
						<el-input disabled v-model="editForm.ratedPower" autocomplete="off"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('shu-chu-dian-liu-fan-wei')" :label-width="formLabelWidth" prop="outputCurrentRange">
						<el-input disabled v-model="editForm.outputCurrentRange" autocomplete="off"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('chong-dian-jie-kou-biao-zhun')" :label-width="formLabelWidth" prop="chargingInterface">
						<el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.chargingInterface">
							<el-option v-for="item in interfaceStandardData" :key="item.value"
								v-bind:label="item.message" v-bind:value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('ruan-jian-xie-yi')" :label-width="formLabelWidth" prop="protocol">
						<el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.protocol">
							<el-option v-for="item in protocolData" :key="item.value" v-bind:label="item.message"
								v-bind:value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
        <el-col :span="12">
          <el-form-item :label="$t('sheng-chan-chang-shang-org')" :label-width="formLabelWidth" prop="manufacturerId">
            <el-input v-model="editForm.manufacturerId" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
				<el-col :span="12">
					<el-form-item :label="$t('sheng-chan-chang-shang')" :label-width="formLabelWidth" prop="manufacturer">
						<el-input v-model="editForm.manufacturer" autocomplete="off"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('zhuang-hu-hao')" :label-width="formLabelWidth" prop="consNo">
						<el-input v-model="editForm.consNo" autocomplete="off"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('fu-yuan-lei-xing')" :label-width="formLabelWidth" prop="auxiliarySourceType">
						<el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.auxiliarySourceType">
							<el-option v-for="item in auxiliarySourceTypeData" :key="item.value"
								v-bind:label="item.message" v-bind:value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('shi-fou-qi-yong-0')" :label-width="formLabelWidth" prop="enabledStateFlag">
						<el-select v-model="editForm.enabledStateFlag" :placeholder="$t('operatingViewOperator.selectPlaceholder')">
							<el-option :label="$t('qi-yong')" value="Y"></el-option>
							<el-option :label="$t('bu-qi-yong')" value="N"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('an-zhuang-ri-qi')" :label-width="formLabelWidth" prop="installDate">
						<el-date-picker v-model="editForm.installDate" type="date" value-format="yyyy-MM-dd"
							:placeholder="$t('xuan-ze-ri-qi-shi-jian')"></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item :label="$t('sheng-chan-ri-qi')" :label-width="formLabelWidth" prop="produceDate">
						<el-date-picker v-model="editForm.produceDate" type="date" value-format="yyyy-MM-dd"
							:placeholder="$t('xuan-ze-ri-qi-shi-jian')"></el-date-picker>
					</el-form-item>
				</el-col>
<!--				<el-col :span="12">
			        <el-form-item :label="$t('shi-fou-gong-xiang')" :label-width="formLabelWidth" prop="isShare">
                <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.isShare">
                  <el-option v-for="item in togetherData" :key="item.value"
                             v-bind:label="item.message" v-bind:value="item.value"></el-option>
                </el-select>
			        </el-form-item>
			      </el-col>
			      <el-col :span="12">
			        <el-form-item :label="$t('gong-xiang-ren')" :label-width="formLabelWidth" prop="sharePhone">
			          <el-input v-model="editForm.sharePhone" autocomplete="off" />
			        </el-form-item>
			      </el-col>-->
				<el-col :span="12">
				        <el-form-item :label="$t('mian-fei-yun-ying-shi-jian')" :label-width="formLabelWidth" prop="freeOperatingTime">
				          <el-date-picker v-model="editForm.freeOperatingTime" type="date" value-format="yyyy-MM-dd" :placeholder="$t('xuan-ze-ri-qi-shi-jian')"></el-date-picker>
				        </el-form-item>
				</el-col>
				<el-col :span="12">
				        <el-form-item :label="$t('chong-dian-biao')" :label-width="formLabelWidth" prop="meterId">

				          <el-select v-model="editForm.meterId"  :placeholder="$t('qing-xuan-ze-dian-biao-qing-xian-xuan-ze-chong-dian-zhan')" >
				            <el-option v-for="item in optionMeter" :key="item.id" :label="item.meterName" :value="item.id">{{item.meterName}}</el-option>
				          </el-select>
				        </el-form-item>
				</el-col>
				<el-col :span="12">
				        <el-form-item :label="$t('shi-fou-zhi-chi-guang-gao')" :label-width="formLabelWidth" prop="advert">
				          <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.advert">
				            <el-option v-for="item in togetherData" :key="item.value"
				                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
				          </el-select>
				        </el-form-item>
				</el-col>
        <el-col :span="12">
          <el-form-item :label="$t('zhuan-fa-ip')" :label-width="formLabelWidth" prop="forwardIp">
            <el-input v-model="editForm.forwardIp" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('zhuan-fa-duan-kou')" :label-width="formLabelWidth" prop="forwardPort">
            <el-input v-model="editForm.forwardPort" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('she-bei-tou-zi-jin-e')" :label-width="formLabelWidth" prop="equipmentInvestment">
            <el-input v-model="editForm.equipmentInvestment" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('chu-chang-de-xu-lie-hao')" :label-width="formLabelWidth" prop="productSn">
            <el-input v-model="editForm.productSn" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ping-jun-gong-lv')" :label-width="formLabelWidth" prop="avgPower">
            <el-input v-model="editForm.avgPower" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
				<!--隐藏id-->
				<el-col :span="12">
					<el-form-item hidden label="id" :label-width="formLabelWidth" prop="id">
						<el-input v-model="editForm.id" autocomplete="off"></el-input>
					</el-form-item>
				</el-col>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="clearEditForm">{{ $t('qu-xiao') }}</el-button>
				<el-button size="small" type="primary" @click.native="editSubmit" :loading="editSubmitLoading">{{ $t('que-ding') }}
				</el-button>
			</div>
		</el-dialog>
		<!-- 设置桩编号 -->
		<!-- <el-dialog title="设置桩编号" :visible.sync="pileShow" width="30" :modal="false" :before-close="pileEditForm">

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click.native="handleClose()">确认</el-button>
			</span>
		</el-dialog> -->
	</div>
</template>

<script>
	import {
		validateInput
	} from '../../../../common/validator'
	import gunApi from '../../../resourceCenter/api/gunApi';
	export default {
		name: "add",
		data() {
		var isPriceVlidator= (rule, value, callback) => {
		       if ( this.stationId == null) {
		          return callback(new Error(this.$t('qing-xuan-ze-chong-dian-zhan')))
		        }else{
		          return callback()
		       }
		      }
			return {
				pileShow: false,
				pileForm: {
					code: '', //运营商编码后三位
					reservedBit1: 0, //保留位，正式0-测试T
					reservedBit2: 0, //保留位
					areaCode: '', //区号
					stationNumber: '', //站序号
					pileNumber: '' //桩序号
				},
				pileState: [{
					value: 0,
					message: this.$t('zheng-shi')
				}, {
					value: 'T',
					message: this.$t('ce-shi')
				}],
				// 桩编号规则
				pileFormRules: {
					code: [{
						required: true,
						message: this.$t('monitoringCenter.opsTreePlaceholder'),
						trigger: 'blur'
					}],
					reservedBit1: [{
						required: true,
						message: this.$t('qing-xuan-ze-chong-dian-zhuang-zhuang-tai'),
						trigger: 'blur'
					}],
					areaCode: [{
						required: true,
						message: this.$t('qing-shu-ru-qu-hao'),
						trigger: 'blur'
					}, {
						min: 3,
						message: this.$t('qing-shu-ru-di-qu-qu-hao-de-qian-san-wei'),
						trigger: 'blur'
					}], //区号
					stationNumber: [{
						required: true,
						message: this.$t('qing-shu-ru-chong-dian-zhan-xu-hao'),
						trigger: 'blur'
					}, {
						min: 3,
						message: this.$t('chong-dian-zhan-xu-hao-wei-san-wei-shu-0'),
						trigger: 'blur'
					}], //站序号
					pileNumber: [{
						required: true,
						message: this.$t('qing-shu-ru-chong-dian-zhuang-xu-hao'),
						trigger: 'blur'
					}, {
						min: 3,
						message: this.$t('chong-dian-zhuang-xu-hao-wei-san-wei-shu-0'),
						trigger: 'blur'
					}] //桩序号
				},
				// 登记充电桩编辑规则
				editFormRules: {
					pileCode: [{
						required: true,
						message: this.$t('qing-shu-zhuang-bian-hao'),
						trigger: 'blur'
					}, {
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 17, true, true, true, false, false, false,
								false)
						},
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: this.$t('qing-shu-ru-zhan-ming-cheng'),
						trigger: 'blur'
					}, {
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 16, true, true, false, false, false, false,
								false)
						},
						trigger: 'blur'
					}],
					pileType: [{
						required: true,
						message: this.$t('qing-xuan-ze-chong-dian-zhuang-lei-xing'),
						trigger: 'blur'
					}],
					protocol: [{
						required: true,
						message: this.$t('qing-xuan-ze-xie-yi-chang-jia'),
						trigger: 'blur'
					}],
					checkConnection: [{
						required: true,
						message: this.$t('qing-xuan-ze-shi-fou-jian-cha-lian-jie'),
						trigger: 'blur'
					}],
					pileTypeId: [{
						required: true,
						message: this.$t('qing-xuan-ze-xing-hao'),
						trigger: 'blur'
					}],
					fastOrSlow: [{
						required: true,
						message: this.$t('qing-xuan-ze-kuai-man-chong'),
						trigger: 'blur'
					}],
          equipmentType: [{
            required: true,
            message: this.$t('qing-xuan-ze-she-bei-lei-xing'),
            trigger: 'blur'
          }],
					chargingInterface: [{
						required: true,
						message: this.$t('qing-shu-ru-chong-dian-jie-kou-biao-zhun'),
						trigger: 'blur'
					}],
					auxiliarySourceType: [{
						required: true,
						message: this.$t('qing-shu-ru-fu-yuan-lei-xing'),
						trigger: 'blur'
					}],
					operatorId: [{
						required: true,
						message: this.$t('monitoringCenter.opsTreePlaceholder'),
						trigger: 'blur'
					}],
					stationId: [{
						required: true,
						message: this.$t('qing-xuan-ze-suo-shu-zhan'),
						trigger: 'blur'
					}],
					enabledStateFlag: [{
						required: true,
						message: this.$t('qing-xuan-ze-shi-fou-qi-yong'),
						trigger: 'blur'
					}],
					installDate: [{
						required: true,
						message: this.$t('qing-xuan-ze-an-zhuang-ri-qi'),
						trigger: 'blur'
					}],
					produceDate: [{
						required: true,
						message: this.$t('qing-xuan-ze-sheng-chan-ri-qi'),
						trigger: 'blur'
					}],
					/*freeOperatingTime: [{required: true, message: '请选择免费运营时间', trigger: 'blur'}],*/
 					meterId: [{required: false, message: this.$t('qing-xuan-ze-chong-dian-biao'), trigger: 'blur'}]
				},
				formLabelWidth: '150px',
				YesNoEnumData: [{
						value: 'Q',
						message: this.$t('shi')
					},
					{
						value: 'N',
						message: this.$t('fou')
					}
				],
			}
		},
		props: {
			editForm: {},
			editFormVisible: false,
			checkConnectionData: "",
			togetherData: "",
			operatorForSelect: "",
			operatorTree: {
				type: Array,
				required: true
			},
			optionMeter:{
			        type: Array,
			        required: true
			      },
			stationsForSelect: {},
			pileTypeForSelect: {},
			fastOrSlowData: "",
      equipmentTypeData: "",
			pileTypeData: "",
			interfaceStandardData: "",
			protocolData: "",
			auxiliarySourceTypeData: "",
			editSubmitLoading: false
		},
		methods: {
			// 确认桩编号
			handleClose() {
				let _this = this;
				this.$refs.pileForm.validate((valid) => {
					if (valid) {
						let pileCode = _this.pileForm.code.substring(_this.pileForm.code.length - 3) + _this
							.pileForm.reservedBit1 +
							_this.pileForm.reservedBit2 + _this.pileForm.areaCode + _this.pileForm.stationNumber +
							_this.pileForm.pileNumber
						// _this.editForm.pileCode = pileCode
						_this.$set (_this.editForm,'pileCode',pileCode)
						_this.editForm.operatorId = _this.pileForm.code
						_this.pileEditForm();
					} else {
						return false;
					}
				});
			},
			// 清空重置表单
			pileEditForm() {
				this.pileShow = false
				this.$refs.pileForm.resetFields();
			},
			//选择运营商
			handleChangeCode(value) {
				let code = value && value.length > 0 ? value[value.length - 1] : ''
				this.pileForm.code = code
				// .substring(code.length-3)
				this.$refs.cascaderPile.dropDownVisible = false
				// this.$emit("operatorSelect", operatorId)
			},

			operatorDisable(item) {
				// 判断是否为潜在运营商
				const flag = (item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved')) ? true :
					false
				return flag
			},
			//对数据进行授权过滤
			setTreeDisable(val) {
				//对 treeList 进行递归操作，禁止选中unchecked和unapproved
				val && val.forEach(item => {
					if ((item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved'))) {
						item.disabled = true; // 如果类型为unchecked或者unapproved，就增加禁用选项
					}
					if (item.children) {
						this.setTreeDisable(item.children);
					}
				});
				return val;
			},
			handleChangeStation(value) {
				let operatorId = value && value.length > 0 ? value[value.length - 1] : ''
				this.editForm.operatorId = operatorId
				this.$refs.cascader.dropDownVisible = false
				this.$emit("operatorSelect", operatorId)
			},
			clearEditForm() {
				let _this = this
				if (this.editForm.id == null || this.editForm == '') {
					this.$confirm(this.$t('paramMonitor.message18')).then(_ => {
						_this.$refs.editForm.clearValidate()
						_this.pileEditForm();
						_this.$emit('closeEditForm')
					}).catch(_ => {})
				} else {
					_this.$refs.editForm.clearValidate()
					_this.pileEditForm();
					_this.$emit('closeEditForm')
				}
			},
			editSubmit() {
				this.$emit("editSubmit", this.$refs.editForm)
			},
			operatorSelect(val) {
				this.$emit("operatorSelect", val)
			},
			stationSelect(val) {
				this.$emit("stationSelect", this.editForm.stationId,this.editForm)
			},
			pileTypeSelect(val) {
				this.$emit("pileTypeSelect", val, this.editForm)
			}
		}
	}
</script>

<style lang="less" scoped>
	/deep/ .edit_form {
		height: auto;

		.el-form-item--mini .el-form-item__content,
		.el-form-item--mini .el-form-item__label {
			line-height: 25px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/deviceManager/add.vue